/**
 * Scripts for use with _Breadcrumbs.cshtml partial
 */
export class Breadcrumbs {
    dom: {
        /** The parent element containing the breadcrumbs partial */
        parent: HTMLElement
        /**  Get the list of links in the breadcrumbs */
        links: () => NodeListOf<HTMLAnchorElement>
    }

    constructor(parent: HTMLElement | null) {
        this.dom = {
            parent: parent ?? document.body,
            links: () => this.dom.parent.querySelectorAll<HTMLAnchorElement>(".breadcrumb-item a")
        };
    }

}
